import { z } from '../zod.js';
import {
  CursorPaginationValidationBaseSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';

export const CustomerListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend({
    search: z.string().optional().meta({
      description: 'Search by email or name. Contains match.',
    }),
    createdAfter: z.iso.datetime().optional().meta({
      description: 'Filter by lower bound of createdAt.',
    }),
    createdBefore: z.iso.datetime().optional().meta({
      description: 'Filter by upper bound of createdAt.',
    }),
  }).refine(
    data =>
      !(
        data.createdAfter &&
        data.createdBefore &&
        Date.parse(data.createdAfter) > Date.parse(data.createdBefore)
      ),
    {
      message: 'createdAfter must be earlier than or equal to createdBefore',
      path: ['createdBefore'],
    },
  ),
);
